/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './dereferenceScope.defs.js'
export { main as default } from './dereferenceScope.defs.js'
